import { Button, Popover, Space } from "antd";
import { FC, useState } from "react";
import Icon from "../../../../assets/icons/icon";
import CardBox, { CardBoxProps } from "../../../../components/cardBox";
import CopyableContent from "../../../../components/copyableContent";
import Details from "../../../../components/detailsList";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import _t from "../../../../lang/translate";
import { checkValidMileage } from "../../../../services/taxService";
import format from "../../../../utilities/formatNumbers";

function isWithinAcceptableRange(mileage: number, documentedMileageThousands: number) {
  const documentedMileage = documentedMileageThousands * 1000;
  return Math.abs(mileage - documentedMileage) <= 2000
}

const MileageDocumentation: FC<CardBoxProps> = (props) => {
  const { taxCase, setTaxCase } = TaxCaseStore.useContainer();
  const [validating, setValidating] = useState<boolean>();
  const { documentedMileage, validDocumentedMileage, mileage } = taxCase.vehicle || {};

  const valid = isWithinAcceptableRange(mileage ?? 0, parseInt(documentedMileage ?? "0"));

  const checkDocumentedMileage = async () => {
    try {
      setValidating(true);
      const { data } = await checkValidMileage(taxCase.id);
      setTaxCase(data);
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setValidating(false);
    }
  };

  return (
    <Details.Item
      label={_t("mileage")}
      className="align-detail-item-center"
      value={
        <Space>
          <Popover content={
            <CardBox {...props}>
              <Details borderLess>
                <Details.Item
                  label={_t("documentedMileage")}
                  value={documentedMileage}
                />
                <Details.Item
                  label={_t("validatedMileage")}
                  value={format.yesOrNo(validDocumentedMileage)}
                />
              </Details>
            </CardBox>

          }>
            <Button onClick={checkDocumentedMileage} shape="circle" type="link" loading={validating}
              className={valid ? "text-success-important text-success-hover" : "text-warning-important text-warning-hover"}
              icon={
                <Icon name={valid ? "seal-check" : "seal-warning"}
                  size="medium" />
              }
            />
          </Popover>

          <CopyableContent contentToCopy={String(mileage || 0)}>
            {format.milage(mileage)}
          </CopyableContent>
        </Space>
      }
    />

  );
};

export default MileageDocumentation;
